<template>
    <div class="home " v-loading="loading" element-loading-text="加载中请稍后。。。">
      <!-- 没有登陆提示 -->
      <el-dialog :visible.sync="dialogStatus" width="420px" center>
        <div class="home-dialog">
          <p class="el-icon-question home-dialog-icon home-dialog-question"></p>
          <p class="el-icon-warning home-dialog-icon home-dialog-warning"></p>
          <span>简历信息确认成功</span>
          <router-link to="/myresume" class="home-dialog-lookbtns">查看简历</router-link>
        </div>
      </el-dialog>

      <div class="contentWidth">

        <div class="flexCentet home-top-login">
          <Search 
            @updateValue="updateValue" 
            @updateCityCode="updateCityCode" 
            :isPosition="true" 
            :keyWords="keyWords" 
            :isHot="true">
          </Search>
        </div>
        <!-- 搜索条件 -->
        <SearchData @updateFormData="updateFormData" :isJob="true" ></SearchData>
        <div class="flexBetween main-box">
          <div class="flexColumn" style="width: 954px;">
          <div v-for="item in jobs" :key="item.id">
            <job-item @updateFavorite="updateFavorite" :datas="item"></job-item>
          </div>
          <pagination
              :total="pagination.totalRow"
              v-model="conditions.pageIndex"
              v-if="pagination.totalRow>0 && !loading"
              @change="pageChange">
          </pagination>
          <prompt v-if="jobs.length < 1 && !loading"></prompt>
          </div>
          
          <div class="shrink main-box-info">
            <login-tab></login-tab>
            <img src="../../assets/images/newicon/jobImg.png" alt="" class="main-box-info-jobimg">
            <div class="flexColumn main-box-info-weichat boxShadow">
              <img src="../../assets/images/newicon/weichatcode.png" />
              <p>扫码关注 高效求职</p>
            </div>
            
          </div>

        </div>
      </div>
      <GetCityByIp></GetCityByIp>
     
    </div>
  </template>
  
  <script>
  import defaultAvatar from "../../assets/images/default-avatar.png";
  import { mapActions, mapState,mapGetters } from "vuex";
  import Search from '../../components/search.vue';
  import SearchData from './components/searchData.vue';
  import JobItem from './components/item.vue';
  import LoginTab from '../../components/loginTab.vue';
  import GetCityByIp from '../../components/getCurrentCity.vue';
  export default {
    components: {
      Search,SearchData,JobItem,LoginTab,GetCityByIp
    },
    name: "home",
    data() {
      return {
        loading: true,
        conditions: {
          cityCode: "",//城市编码
          parkCode:"",//区编码
          locationCode:"",//园区编码 
          industryType:"", //行业类型
          financingType: "", //融资情况
          qualificationsType: "", //学历
          workExperience: "", //工作经验
          name:"",//职位名称或公司
          // minimum:0, //薪水最小值
          // maximum:0, //薪水最大值
          positionType: "", //招聘类型-社招、校招、兼职
          positionKind:"", //职位类型
          recommended:"", //热招职位
          update24h:"",   //24h 更新
          pageIndex: 1, //当前页码
          pageSize: 10,
        },
        dialogStatus: false, //提示弹窗
        keyWords:null,
      };
    },
    computed: {
      ...mapState({
        screening: state => state.dictionary.screening,
        jobs: state => state.jobs.jobList, //工作列表
        pagination: state => state.jobs.pagination,
        captchaSrc: state => state.user.captcha, //图形验证码
        shlefInfo: state => state.user.info, //个人信息
        cityCodes:state => state.jobs.cityCodeText,

      }),
      ...mapGetters([
         "qualificationsType",//学历要求
         "industryType",//行业类型
         "positionType",//职位类型
         "scale",       //公司规模
         "financingType",//融资情况
         "companyType", //公司类型
         "isLogin"
      ]),
      defaultAvatar() {
        return defaultAvatar;
      }
    },
    async created() {
      for (const key in this.$route.query) {
        if (this.$route.query[key])
          this.conditions[key] = this.$route.query[key];
          this.keyWords = this.$route.query.name;
      }
      await this.getJobsList();
      await this.getPositionArea();
      await this.getHotJob();
      await this.getAllJob();
    },
    methods: {
      ...mapActions([
        "getJobs",
        "login",
        "addFavorite",
        "deleteFavorite",
        "changeFavoriteState",
        "getInitDate",
        "giveThumbsUp",
        "unGiveThumbsUp",
        "getPositionArea",
        "getHotJob",
        "getAllJob",   //所有职位
      ]),

      //页码改变请求数据
      pageChange(e){
        this.conditions.pageIndex = e;
        this.getJobsList();
      },
      //根据条件查询职位列表
      updateFormData(formData){
        for(let key in formData){
          this.conditions[key] = formData[key]
        }
        this.search();
      },

      //根据关键字或热门职位查询
      updateValue(value){
        //console.log(value,88888)
        // this.conditions[key] = value[key];
        for(let key in value){
          this.conditions[key] = value[key]
        }
        this.search();
      },
      // 区域选择查询职位
      updateCityCode(){
        this.conditions.cityCode = this.cityCodes;
        this.search();
      },
      //职位的收藏与取消
      async updateFavorite(id,collect){
        let idx = this.jobs.findIndex(item=>item.id === id)
        if(collect){ //取消收藏
          const res = await this.deleteFavorite(id);
          if (res) {
            this.jobs[idx].favorite = false;
            this.$message({
              message: "取消收藏!",
              type: "success"
            });
          }else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        }else{ //收藏
          const res = await this.addFavorite(id);
          if (res && res.code == 200) {
            this.jobs[idx].favorite = true;

            this.$message({
              message: "收藏成功!",
              type: "success"
            });
          } else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        }
      },

      // 获得筛选工作列表
      async getJobsList() {
        this.loading = true;
        this.conditions.cityCode = this.cityCodes;
        await this.getJobs({...this.conditions})
        this.loading = false;
      },
      // 搜索岗位或者企业
      async search() {
        this.conditions.pageIndex = 1;
        this.getJobsList();
      },
    },
    watch: {}
  };
  </script>
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  @yellowColor:#FF8A16;
  .home {
    padding-top: 30px;
    background: linear-gradient(360deg, #F9FBFF 0%, #DCEAFF 100%);
    padding-bottom: 30px;
    .main-box{
      align-items: flex-start;
      &-info{
        width: 302px;
        &-login{
          width: 302px;
          background: #FFFFFF;
          box-sizing: border-box;
          box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
          border-radius: 6px;
          padding: 10px;
          margin-bottom: 24px;
        
         
         
        }
        &-jobimg{
          width: 100%;
        }
        &-weichat{
          background:  @whiteColor;
          padding: 24px;
          margin-top: 20px;
          img{
            width: 254px;
            height: 254px;
            margin-bottom: 12px;
          }
          p{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color:  @mainFontCol;
          }
        }
      }
      /deep/.el-pager{
        li{
          background: none;
          .active{
            background-color: none;

          }
        }
      } 


    }
    .home-top-login{
        align-items: flex-start;
        .login-more{
            box-sizing: border-box;
            width: 310px;
            height: 46px;
            line-height: 44px;
            box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
            border-radius: 6px;
            border: 1px solid @mianColor;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @mianColor;
            letter-spacing: 2px;
            padding: 0 32px;
            cursor: pointer;
            .login-label{
                color: @mianColor;
            }
            div{
                position: relative;
                &:first-child{
                    &::after{
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 24px;
                        right: -24px;
                        background: @mianColor;
                    }
                }
            }
            img{
                width: 24px;
                height: 24px;
                margin-right: 6px;
            }
        }
    }
    .search {
      width: 100%;
      height: 108px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
     
    }
    .el-dialog__body {
      padding: 10px 0 47px;
    }
    &-dialog {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 18px;
      color: #333;
      &-icon {
        width: 40px;
        height: 40px;
        font-size: 42px;
        text-align: center;
        line-height: 40px;
        margin-bottom: 10px;
      }
      &-warning {
        color: #ff5555;
        font-size: 38px;
      }
      &-question {
        color: #049cfd;
      }
      &-lookbtns {
        width: 80px;
        height: 30px;
        background: #049cfd;
        font-size: 14px;
        color: #fff;
        border: 0;
        line-height: 30px;
        margin-top: 40px;
        padding: 0;
        display: block;
        text-align: center;
      }
    }
  }
  </style>
  